<template>
  <div class="signin">

    <md-dialog v-if="outDated" :md-active.sync="showBrowser" :md-backdrop="false">
      <md-card-content>
        <div class="chrome-description">{{$t('updateText')}}</div>
      </md-card-content>

    </md-dialog>
    <div class="panel">
      <div id="background">
      </div>
      <div class="info">
        <img src="imgs/neowrk.png" width="450">
        <span class="description">{{$t('suppliers')}}</span>
        <md-button class="md-raised md-primary" id="buttonLogin" @click="_signin">
          <div>{{$t('signIn')}}</div>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SignIn',
  data: () => ({
    username: '',
    password: '',
    outDated: false,
  }),
  methods: {
    ...mapActions('Auth', ['signIn']),
    ...mapActions('Global', ['showLoading']),
    _signin () {
      this.showLoading()
      this.signIn()
    },
    checkVersion () {
      var nAgt = navigator.userAgent
      var browserName = navigator.appName
      var fullVersion = '' + parseFloat(navigator.appVersion)
      var majorVersion = parseInt(navigator.appVersion, 10)
      var nameOffset, verOffset, ix

      // In MSIE, the true version is after 'MSIE' in userAgent
      if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        browserName = 'Microsoft Internet Explorer'
        fullVersion = nAgt.substring(verOffset + 5)
      } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        browserName = 'Chrome'
        fullVersion = nAgt.substring(verOffset + 7)
      } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        browserName = 'Safari'
        fullVersion = nAgt.substring(verOffset + 7)
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
          fullVersion = nAgt.substring(verOffset + 8)
        }
      } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        browserName = 'Firefox'
        fullVersion = nAgt.substring(verOffset + 8)
      } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset)
        fullVersion = nAgt.substring(verOffset + 1)
        if (browserName.toLowerCase() === browserName.toUpperCase()) {
          browserName = navigator.appName
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(';')) !== -1) {
        fullVersion = fullVersion.substring(0, ix)
      }
      if ((ix = fullVersion.indexOf(' ')) !== -1) {
        fullVersion = fullVersion.substring(0, ix)
      }

      majorVersion = parseInt('' + fullVersion, 10)
      if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion)
        majorVersion = parseInt(navigator.appVersion, 10)
      }

      if (browserName === 'Microsoft Internet Explorer') {
        if (majorVersion < 11) {
          this.outDated = true
        }
      } else if (browserName === 'Chrome') {
        if (majorVersion < 64) {
          this.outDated = true
        }
      } else if (browserName === 'Firefox') {
        if (majorVersion < 61) {
          this.outDated = true
        }
      } else if (browserName === 'Safari') {
        if (majorVersion < 7) {
          this.outDated = true
        }
      }
    }
  },
  computed: {
    ...mapGetters('Global', ['loading'])
  }
}
</script>

<style lang="scss" scoped>
.signin {
  width: 100%;
  height: 100%;

  .panel{
    display: flex;
    align-items: center;

    #background{
      background-image: url(/imgs/home.jpg);
      width: 60vw;
      height: 100vh;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      @media only screen and (max-width: 1023px) {
        display: none;
      }

    }
  }

  .info {
    padding-bottom: 11px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40vw;
    height: 100vh;
    @media only screen and (max-width: 1023px) {
      width: 100vw;
    }
    img{
      padding: 30px;
    }
  }

  .description {
    color: #6d6e70;
    font-size: 17px;
    margin: 0 10px 20px 10px;
  }

  .header{
    color: #000000;
    margin: 30px 0 10px 0;
  }
}
.md-dialog{
  top: 88%;

  .chrome-description{
    margin: 15px;
    text-align: center;
  }

}
</style>
